 /* eslint-disable */ 

import "primeicons/primeicons.css";
import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'

import Aura from '@primeuix/themes/aura';

import 'primeicons/primeicons.css'

import PrimeVue from "primevue/config";
import Accordion from 'primevue/accordion';
import Chip from 'primevue/chip';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import Card from 'primevue/card';
import Checkbox from 'primevue/checkbox';
import Column from 'primevue/column';
import ColorPicker from 'primevue/colorpicker';
import DataView from 'primevue/dataview';
//import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import Listbox from 'primevue/listbox';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import RadioButton from 'primevue/radiobutton';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';

import TabPanel from 'primevue/tabpanel';


import Toolbar from 'primevue/toolbar';
import Tree from 'primevue/tree';
import TreeSelect from 'primevue/treeselect';
import Textarea from 'primevue/textarea';
import TreeTable from 'primevue/treetable';
import Timeline from 'primevue/timeline';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import Panel from 'primevue/panel';
import PickList from 'primevue/picklist';
import ProgressSpinner from 'primevue/progressspinner';
import SelectButton from 'primevue/selectbutton';
import Slider from 'primevue/slider';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import SplitButton from 'primevue/splitbutton';
import FileUpload from 'primevue/fileupload';
import DataTable from 'primevue/datatable';
import ColumnGroup from 'primevue/columngroup';  
import Row from 'primevue/row'; 

const app = createApp(App);
//app.use(PrimeVue);

// app.use(ToastService);
// app.use(ConfirmationService);
// app.directive('tooltip', Tooltip);

app.use(PrimeVue, {
    // Default theme configuration
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.my-app-dark',
        }
    }
 });

 app.use(router);


app.component('Menu', Menu);
app.component('Accordion', Accordion);
app.component('AutoComplete', AutoComplete);
app.component('Button', Button);
app.component('Card', Card);
app.component('Checkbox', Checkbox);
app.component('Column', Column);
app.component('ColorPicker', ColorPicker);
app.component('DataTable', DataTable);
app.component('DataView', DataView);
app.component('Chip', Chip);
//app.component('DataViewLayoutOptions', DataViewLayoutOptions);
app.component('Dialog', Dialog);
app.component('Divider', Divider);
app.component('InputNumber', InputNumber );
app.component('InputText', InputText);
app.component('Listbox', Listbox);
app.component('Toast', Toast);
app.component('ConfirmDialog', ConfirmDialog);
app.component('RadioButton', RadioButton);
app.component('Message', Message);
app.component('MultiSelect', MultiSelect);
app.component('TabPanel', TabPanel);
app.component('Toolbar', Toolbar);
app.component('Tree', Tree);
app.component('TreeSelect', TreeSelect);
app.component('TreeTable', TreeTable);
app.component('Textarea', Textarea);
app.component('Timeline', Timeline);
app.component('Panel', Panel);
app.component('PickList', PickList);
app.component('ProgressSpinner', ProgressSpinner);
app.component('SelectButton', SelectButton);
app.component('Slider', Slider);
app.component('Splitter', Splitter);
app.component('SplitterPanel', SplitterPanel);
app.component('SplitButton', SplitButton);
app.component('FileUpload', FileUpload);
app.component('ColumnGroup', ColumnGroup);
app.component('Menubar', Menubar );;
app.component('Row', Row);

app.mount('#app')

